import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=0b92b4c2&scoped=true&"
import script from "./Talent.vue?vue&type=script&lang=js&"
export * from "./Talent.vue?vue&type=script&lang=js&"
import style0 from "./Talent.vue?vue&type=style&index=0&id=0b92b4c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92b4c2",
  null
  
)

export default component.exports